/** Verification comes only from the backend's per-field contract, never billing. */
function contactColumnKey(column) {
  return String(column || '').trim().toLowerCase().replace(/[\s-]+/g, '_');
}

export function contactChannelForColumn(column) {
  const key = contactColumnKey(column);
  if (/^lead_(?:contact_)?emails(?:_\d+)?$/.test(key)) return 'email';
  if (/^lead_(?:contact_)?(?:phones|phone_numbers)(?:_\d+)?$/.test(key)) return 'phone';
  if (/^lead_(?:contact_)?(?:linkedin|linkedin_profiles)(?:_\d+)?$/.test(key)) return 'linkedin';
  return null;
}

export function contactRunForColumn(column) {
  if (!contactChannelForColumn(column)) return null;
  const suffix = contactColumnKey(column).match(/_(\d+)$/);
  return suffix ? Number(suffix[1]) : 1;
}

export function contactFieldForValue(contacts, channel, value, run = null) {
  const target = String(value || '').trim().toLowerCase();
  for (const contact of Array.isArray(contacts) ? contacts : []) {
    if (run !== null && (contact.lead_contact_run ?? 1) !== run) continue;
    const field = (contact?.field_status || contact?.fieldStatus)?.[channel];
    if (field?.value && String(field.value).trim().toLowerCase() === target) return field;
  }
  return null;
}

export function contactStatusPresentation(field) {
  if (!field?.value) return null;
  if (field.status === 'verified') return {
    label: 'Verified', color: 'success', tooltip: 'Independently confirmed.',
  };
  if (field.status === 'provider_reported') return {
    label: 'From provider', color: 'default',
    tooltip: field.source ? `From ${field.source}, not independently verified.` : 'Not independently verified.',
  };
  if (field.status === 'unconfirmable') return {
    label: 'Unconfirmable', color: 'warning',
    tooltip: "This company's mail server accepts every address, so it can't be confirmed.",
  };
  return null;
}
